<template>
  <div class="flex h-full flex-col space-y-2">
    <div
      v-if="choice.features.length > 0"
      class="flex items-center space-x-3 text-xs font-medium"
    >
      <div
        v-for="feature in choice.features"
        :key="feature.type"
        class="fare-feature-tag"
        :class="[`--${feature.type}`]"
      >
        <component :is="feature.icon" class="h-4 w-4" />
        <span>
          {{ feature.text }}
        </span>
      </div>
    </div>
    <slot name="title" v-bind="{ title: choice.name }">
      <h3 class="text-text-neutral-primary text-lg font-bold">
        {{ choice.name }}
      </h3>
    </slot>
    <FareServices :services="choice.descriptions" :fare-idx="fareIdx" />
    <div class="flex-1" />
    <div class="flex items-center justify-between">
      <div class="space-y-1">
        <p class="space-x-1 text-lg font-bold">
          <span
            v-price="choice.price.amount"
            class="text-text-neutral-primary"
          ></span>
          <span
            v-if="choice.price.initial_amount"
            v-price="choice.price.initial_amount"
            class="text-text-neutral-quaternary text-xs font-normal line-through"
          ></span>
        </p>
        <slot
          name="cashback"
          v-bind="{ cashbackAmount, isCashbackError, isCashbackLoading }"
        />
      </div>
      <slot name="button" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { freedomCashbackModel } from 'freedom-shared';

  import { api } from '@/shared/api';

  import FareServices from './FareServices.vue';
  import type { FareFamilyChoiceSpec } from '../model';

  const props = defineProps<{
    choice: FareFamilyChoiceSpec;
    fareIdx?: number;
  }>();

  const {
    amount: cashbackAmount,
    isError: isCashbackError,
    isLoading: isCashbackLoading,
  } = freedomCashbackModel.useFreedomCashback({
    pfm: api,
    offerPrice: props.choice?.price?.amount,
  });
</script>

<style scoped>
  .fare-feature-tag {
    @apply flex items-center space-x-0.5;
    &.--recommended {
      @apply stroke-green-500 text-green-500;
    }
    &.--discount {
      @apply text-text-negative-primary;
    }
  }
</style>
